import { createComponent } from '@bigyouth/base'

import * as features from './features/exports/form'

Object.values(features).forEach(createComponent)
